import { render, staticRenderFns } from "./InitiativeGroupQuickCreate.vue?vue&type=template&id=4b52b636&scoped=true"
import script from "./InitiativeGroupQuickCreate.vue?vue&type=script&lang=js"
export * from "./InitiativeGroupQuickCreate.vue?vue&type=script&lang=js"
import style0 from "./InitiativeGroupQuickCreate.vue?vue&type=style&index=0&id=4b52b636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52b636",
  null
  
)

export default component.exports